export default {
    book: 'Louer {product}',
    age_limit: 'Plus de {age} ans uniquement',
    upgrade_product: 'Améliorer le produit',
    choose_product: 'Choisir {product}',
    days: '{count} jour | {count} jours',
    login_register: "S'identifier/S'enregistrer",
    keyless_benefits: {
        label: 'Accès direct au véhicule {0}',
        highlight: 'rental service™',
        list: {
            cant_lose_the_key: 'Assurance complète',
            zero_excess: 'zéro excédent',
            phone_as_a_key: 'Le téléphone est votre clé',
            straight_to_car: "Pas d'attente",
            no_queues: "Pas de file d'attente",
            online_id_check: "Vérification d'identité en ligne",
            self_checkout: 'Récupération libre',
        },
    },
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/fr/quotes/vehicle_card.js